import { createSelector } from 'reselect';
import { get } from 'lodash/object';

export const requestSuccessSelector = state => state.requestDataSuccess;

export const successActionSelector = createSelector(
  requestSuccessSelector,
  subState => subState.action
);

export const successServiceNumberSelector = createSelector(
  requestSuccessSelector,
  subState => get(subState, 'data.service_number')
);
